import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView')
  },
  {
    path: '/order-count',
    name: 'Order Count',
    component: () => import(/* webpackChunkName: "about" */ '../views/ReportOrderCountView')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/datatable',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/DataTableView')
  },
  {
    path: '/daily-report',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/DailyReportTableData')
  },
  {
    path: '/map',
    name: 'map',
    component: () => import(/* webpackChunkName: "about" */ '../views/MapView')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserView')
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: () => import(/* webpackChunkName: "about" */ '../views/CouponView')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import(/* webpackChunkName: "about" */ '../views/OrderView')
  },
  {
    path: '/place',
    name: 'place',
    component: () => import(/* webpackChunkName: "about" */ '../views/PlaceView')
  },
  {
    path: '/show',
    name: 'show',
    component: () => import(/* webpackChunkName: "about" */ '../views/ShowView')
  },
  {
    path: '/shops',
    name: 'shops',
    component: () => import(/* webpackChunkName: "about" */ '../views/ShopsView')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
